import type { CSSProperties } from "react";

const COLORS = ["#c76647", "#547047", "#d2a33b", "#4f7691", "#282623"];
const PIECES = Array.from({ length: 36 }, (_, index) => {
  const side = index % 2 === 0 ? -1 : 1;
  const lane = Math.floor(index / 2);
  return {
    id: index,
    color: COLORS[index % COLORS.length],
    originX: side < 0 ? 28 : 72,
    translateX: side * (12 + (lane * 17) % 42),
    translateY: -18 - (lane * 19) % 48,
    rotation: side * (90 + (index * 47) % 280),
    delay: (index % 9) * 0.035,
    duration: 1.45 + (index % 6) * 0.09,
    round: index % 4 === 0,
  };
});

type ConfettiStyle = CSSProperties & Record<`--${string}`, string>;

export function CelebrationConfetti() {
  return (
    <div className="celebration-confetti" aria-hidden="true">
      {PIECES.map((piece) => (
        <span
          key={piece.id}
          className={piece.round ? "celebration-confetti__piece celebration-confetti__piece--round" : "celebration-confetti__piece"}
          style={{
            "--confetti-color": piece.color,
            "--confetti-origin-x": `${piece.originX}%`,
            "--confetti-x": `${piece.translateX}vw`,
            "--confetti-y": `${piece.translateY}vh`,
            "--confetti-rotation": `${piece.rotation}deg`,
            "--confetti-delay": `${piece.delay}s`,
            "--confetti-duration": `${piece.duration}s`,
          } as ConfettiStyle}
        />
      ))}
    </div>
  );
}
